import { string, object } from "yup";

export const CodeRequestValidationSchema = object({
    email: string().required("Bitte geben Sie eine E-Mail Adresse an.")
});
